import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {FirebaseTokenService} from '../auth/firebase-token';
import {catchError, from, switchMap, throwError} from 'rxjs';
import {AuthReadyService} from '../auth/auth-ready.service';

/*export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // 🚨 No interceptar peticiones de login
  if (req.url.includes('login')) {
    return next(req);
  }

  const tokenService = inject(FirebaseTokenService);
  const authReady = inject(AuthReadyService);

  return from(authReady.waitUntilReady()).pipe(
    switchMap(() => from(tokenService.getFreshIdToken())),
    switchMap(token => {

      if (!token) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        })
      );
    })
  );
};*/

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // No interceptar peticiones de login
  if (req.url.includes('login')) {
    return next(req);
  }

  const tokenService = inject(FirebaseTokenService);
  const authReady = inject(AuthReadyService);

  return from(authReady.waitUntilReady()).pipe(
    switchMap(() => from(tokenService.getFreshIdToken())),
    switchMap(token => {

      const authReq = token
        ? req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          })
        : req;

      return next(authReq).pipe(
        catchError(err => {

          if (err instanceof HttpErrorResponse && err.status === 401) {

            console.warn('Token expirado → refrescando...');

            return from(tokenService.forceRefresh()).pipe(
              switchMap(newToken => {

                if (!newToken) {
                  return throwError(() => err);
                }

                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`
                  }
                });

                return next(retryReq);
              })
            );
          }

          return throwError(() => err);
        })
      );
    })
  );
};
